"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.urlTokens = exports.SOCIAL = void 0;
exports.isSocial = isSocial;
exports.isExtendedSocial = isExtendedSocial;
var SOCIAL;
(function (SOCIAL) {
    // FACEBOOK = 'FACEBOOK',
    SOCIAL["GOOGLE"] = "GOOGLE";
    SOCIAL["LINKEDIN"] = "LINKEDIN";
    SOCIAL["APPLE"] = "APPLE";
})(SOCIAL || (exports.SOCIAL = SOCIAL = {}));
function isSocial(val) {
    if (typeof val !== 'string') {
        return false;
    }
    return ['FACEBOOK', 'GOOGLE', 'LINKEDIN', 'APPLE'].includes(val);
}
function isExtendedSocial(val) {
    if (typeof val !== 'string') {
        return false;
    }
    if (val === 'TRADITIONAL') {
        return true;
    }
    return isSocial(val);
}
exports.urlTokens = ['workEmailVerifyToken'];
//# sourceMappingURL=types.js.map